import { render, staticRenderFns } from "./entry.vue?vue&type=template&id=5457ef5e&scoped=true"
import script from "./entry.vue?vue&type=script&lang=js"
export * from "./entry.vue?vue&type=script&lang=js"
import style0 from "./entry.vue?vue&type=style&index=0&id=5457ef5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457ef5e",
  null
  
)

export default component.exports